module.exports = __webpack_public_path__ + "img/yacht-1.712ebda4.jpg";